(function () {
  'use strict';

  let initialized = new WeakSet();

  const initStepsSplit = () => {
    const sections = document.querySelectorAll('[id^="steps-split-"]');

    sections.forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);

      const sectionId = section.id.replace('steps-split-', '');
      const visual = section.querySelector(`#steps-split-visual-${sectionId}`);
      const titleEl = section.querySelector(`#steps-split-title-${sectionId}`);
      const descEl = section.querySelector(`#steps-split-description-${sectionId}`);
      const buttons = Array.from(section.querySelectorAll('.steps-split__btn'));

      if (!visual || !titleEl || !descEl || buttons.length === 0) return;

      let isTransitioning = false;

      const setFromBtn = (btn) => {
        if (isTransitioning) return;
        isTransitioning = true;

        const leftCol = section.querySelector('.steps-split__left');

        requestAnimationFrame(() => {
          buttons.forEach((b) => b.classList.toggle('active', b === btn));

          const imageUrl = btn.dataset.image;
          const imagePosition = btn.dataset.imagePosition || 'center top';
          const title = btn.dataset.title;
          const description = btn.dataset.description;

          if (imageUrl) {
            const img = visual.querySelector('.steps-split__img');
            if (img) {
              visual.classList.add('is-fading');
              if (leftCol) leftCol.classList.add('is-fading');

                const newImg = new Image();
                newImg.src = imageUrl;
                newImg.alt = title || 'Step image';
                newImg.className = 'steps-split__img';
                newImg.decoding = 'async';
                newImg.style.width = '100%';
                newImg.style.height = '100%';
                newImg.style.objectFit = 'cover';
                newImg.style.objectPosition = imagePosition;
              newImg.style.opacity = '0';
              newImg.style.position = 'absolute';
              newImg.style.top = '0';
              newImg.style.left = '0';
              newImg.style.transition = 'opacity 0.6s ease';

                newImg.onload = () => {
                // Wait for the fade out to be well underway
                setTimeout(() => {
                  requestAnimationFrame(() => {
                    // Update text content while faded out
                    if (title) titleEl.textContent = title;
                    if (description) {
                      descEl.innerHTML = description.replace(/\n/g, '<br>');
                    }

                    // Append the new image on top
                    visual.appendChild(newImg);

                    // Force reflow
                    newImg.offsetHeight;

                    // Fade in everything
                    newImg.style.opacity = '1';
                    if (leftCol) leftCol.classList.remove('is-fading');

                    // After the fade-in is complete, clean up the old image
                    setTimeout(() => {
                      if (img && img.parentNode) {
                        img.parentNode.removeChild(img);
                      }
                      // Reset styles to original state
                      newImg.style.position = '';
                      newImg.style.top = '';
                      newImg.style.left = '';
                      newImg.style.transition = '';
                    visual.classList.remove('is-fading');
                    isTransitioning = false;
                    }, 600);
                  });
                }, 300); // Start fade-in halfway through fade-out
                };

                newImg.onerror = () => {
                  visual.classList.remove('is-fading');
                if (leftCol) leftCol.classList.remove('is-fading');
                  isTransitioning = false;
                };
            }
          } else {
            // No image case, just update text instantly or with a small fade
            if (title) titleEl.textContent = title;
            if (description) descEl.innerHTML = description.replace(/\n/g, '<br>');
            isTransitioning = false;
          }
        });
      };

      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          setFromBtn(btn);
        }, { passive: true });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStepsSplit);
  } else {
    initStepsSplit();
  }

  document.addEventListener('shopify:section:load', () => {
    initialized = new WeakSet();
    initStepsSplit();
  });
})();
